import { render } from "./FormSelect.vue?vue&type=template&id=5f8e313f&scoped=true&ts=true"
import script from "./FormSelect.vue?vue&type=script&lang=ts"
export * from "./FormSelect.vue?vue&type=script&lang=ts"

import "./FormSelect.vue?vue&type=style&index=0&id=5f8e313f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8e313f"]])

export default __exports__